import { ChoiceCard } from '@eventbrite/marmalade';
import React from 'react';
import { TicketContextProvider } from './context';
import { QuantityRemaining } from './QuantityRemaining';
import { ReadMoreButton } from './ReadMoreButton';
import { ReadMoreContent } from './ReadMoreContent';
import { SalesEndMessage } from './SalesEndMessage';
import styles from './TicketCard.module.scss';
import { TicketCosts } from './TicketCosts';
import { TicketDescription } from './TicketDescription';
import { TicketHeading } from './TicketHeading';
import { TicketStepper } from './TicketStepper';
import type { TicketCardType } from './types';

export const TicketCard: React.FC<TicketCardType> = ({
    description,
    displayFlags,
    expanded,
    fee,
    id,
    name,
    price,
    salesEndMessage,
    tax,
    quantityRemaining,
    characteristics,
}) => {
    const { showSalesEndDate, showRemaining } = displayFlags;

    return (
        <TicketContextProvider
            value={{
                description,
                displayFlags,
                expanded,
                fee,
                id,
                name,
                price,
                salesEndMessage,
                tax,
                quantityRemaining,
                //here we need to add the function that sends the quantity to the checkout iframe
                onQuantityChange: () => undefined,
                characteristics,
            }}
        >
            <ChoiceCard className={styles.root}>
                <div className={styles.information}>
                    <div className={styles.header}>
                        <div className={styles.headerLeft}>
                            <TicketHeading />
                        </div>
                        <div className={styles.headerRight}>
                            <TicketStepper
                                quantityRemaining={quantityRemaining || '0'}
                                //we don't have ticketClassId yet in the context
                                ticketClassId={''}
                            />
                        </div>
                    </div>
                    <div className={styles.body}>
                        <div className={styles.bodyRow}>
                            <TicketCosts />
                            <ReadMoreButton />
                        </div>
                        <ReadMoreContent>
                            <>
                                {(showSalesEndDate || showRemaining) && (
                                    <div className={styles.bodyRow}>
                                        <SalesEndMessage />
                                        <QuantityRemaining />
                                    </div>
                                )}
                                {description && (
                                    <div className={styles.bodyRow}>
                                        <TicketDescription />
                                    </div>
                                )}
                            </>
                        </ReadMoreContent>
                    </div>
                </div>
            </ChoiceCard>
        </TicketContextProvider>
    );
};
